module.exports = __webpack_public_path__ + "img/logo.8dfb9626.svg";